import { Feature } from '@/pinia/feature'

const detailHeaders = [
  {
    en: 'Type',
    sv: 'Typ'
  },
  {
    en: 'Number',
    sv: 'Antal'
  }
]

const format = {
  format: { type: 'locale-format-string', format: { sv: '%s st', en: '%s' } }
}

export const ticketAnalysis: Feature = {
  name: 'ticket',
  enabled: true,
  isRoute: true,
  access: ['FEAT_TICKET-ANALYSIS_READER'],
  title: {
    en: 'ToDo’s',
    sv: 'Ärenden'
  },
  component: 'DashboardFeature',
  props: {
    defaultFilters: {
      calendar: {
        quickSelect: 'last7days'
      }
    },
    icon: 'IconCheckDone1'
  },
  children: [
    {
      name: 'filters',
      enabled: true,
      title: {
        en: 'Filters',
        sv: 'Filter'
      },
      component: 'TicketAnalysisFilters'
    },
    {
      name: 'data',
      enabled: true,
      title: {
        en: 'Data',
        sv: 'Data'
      },
      children: [
        {
          name: 'overview',
          enabled: true,
          title: {
            en: 'Overview',
            sv: 'Översikt'
          },
          isRoute: true,
          component: 'DashboardDataSectionFlat',
          props: {
            dataSources: [
              {
                id: 'ticket.measurement.number.value',
                type: 'fetch',
                fetch: 'fetch.ticket.measurements',
                path: `kpis[0].values[0].value`
              },
              {
                id: 'ticket.measurement.number.colored-entities',
                type: 'fetch',
                fetch: 'fetch.ticket.measurements',
                transform: {
                  id: 'ticket.colored-entities',
                  index: 1
                }
              },
              {
                id: 'ticket.measurement.number.details',
                type: 'fetch',
                fetch: 'fetch.ticket.measurements.detail',
                transform: {
                  id: 'tickets.detail'
                }
              },
              {
                id: 'ticket.measurement.number.timeseries',
                type: 'fetch',
                fetch: 'fetch.ticket.timeseries',
                transform: {
                  id: 'tickets.timeseries'
                }
              },
              {
                id: 'ticket.measurement.number.colorscale',
                type: 'value',
                value: {
                  type: 'INTERPOLATE',
                  cutoffs: [
                    {
                      value: 17,
                      color: '#0BA5EC'
                    },
                    {
                      value: 19,
                      color: '#36CFC9'
                    },
                    {
                      value: 21,
                      color: '#73D13D'
                    },
                    {
                      value: 24,
                      color: '#FFA940'
                    },
                    {
                      value: 28,
                      color: '#FF4D4F'
                    }
                  ]
                }
              }
            ]
          },
          children: [
            {
              name: 'tickets',
              title: {
                en: 'Number of tickets',
                sv: 'Antal ärenden'
              },
              enabled: true,
              component: 'MainMeasurementCard',
              props: {
                initialShowOnMap: true,
                value: {
                  dataSource: 'ticket.measurement.number.value',
                  format
                },
                coloredEntities: {
                  dataSource: 'ticket.measurement.number.colored-entities'
                },
                table: {
                  dataSource: 'ticket.measurement.number.details',
                  headers: detailHeaders,
                  sort: { col: 1, field: 'number', direction: 'desc' }
                },
                colorLegend: {
                  hideMean: true
                },
                color: '#40A9FF',
                colorScale: undefined
              },
              children: [
                {
                  name: 'legend',
                  enabled: true,
                  component: 'InteractiveColorLegend',
                  title: {
                    en: 'Number of tickets',
                    sv: 'Antal ärenden'
                  },
                  props: {
                    fromColor: '#BAE7FF',
                    toColor: '#0050B3',
                    middleColor: '#40A9FF',
                    format: format
                  }
                }
              ]
            },
            {
              name: 'timeseries',
              enabled: true,
              title: {
                en: 'Change over time',
                sv: 'Förändring över tid'
              },
              info: {
                sv: 'Grafen visar antal ärenden över tid.',
                en: 'The graph shows the number of tickets over time.'
              },
              component: 'CardChart',
              props: {
                enableFullscreen: true,
                chart: {
                  type: 'timeseries',
                  dataFormat: {
                    format: {
                      type: 'intl-number',
                      maximumFractionDigits: 0
                    }
                  },
                  labels: [
                    {
                      sv: 'Antal ärenden',
                      en: 'Number of tickets'
                    }
                  ],
                  lineFormats: [
                    {
                      style: 'solid',
                      color: '#40A9FF'
                    }
                  ],
                  gradientBelow: true,
                  // colorScale: 'ticket.measurement.number.colorscale',
                  dataSources: ['ticket.measurement.number.timeseries'],
                  missingDataMessage: {
                    en: 'Missing data',
                    sv: 'Saknar data'
                  }
                }
              }
            }
          ]
        },
        {
          name: 'ticketlist',
          enabled: true,
          title: {
            en: 'Ticket list',
            sv: 'Ärendelista'
          },
          isRoute: true,
          component: 'DashboardDataSectionFlat',
          info: {
            en: 'Info about ticket list.',
            sv: 'Info om ärendelista'
          },
          props: {
            dataSources: []
          },
          children: [
            {
              name: 'ticket-list',
              enabled: true,
              title: {
                en: 'Ticket list',
                sv: 'Ärendelista'
              },
              component: 'TicketListTable',
              props: {},
              children: []
            }
          ]
        }
      ]
    }
  ]
}
